import { game } from "native";

import { balance } from "stores/balance";

import Exchange from "./exchange.svelte";

import "commerce/gw2.css";

game.initSession();

game.initNative()
.then(() => {
    balance.updateBalance({
        type   : "coins",
        amount : window.native.stats.coins
    });

    balance.updateBalance({
        type   : "gems",
        amount : window.native.stats.gems
    });

    // this gets triggered when a txn occurs, NOT on initial balance load
    game.on("stats", stats => {
        if (stats.coins !== undefined) {
            balance.updateBalance({
                type   : "coins",
                amount : stats.coins
            });
        }

        if (stats.gems !== undefined) {
            balance.updateBalance({
                type   : "gems",
                amount : stats.gems
            });
        }
    });

    new Exchange({
        target : document.getElementById("mount"),
    });
})
.catch(err => {
    console.log(err);
    // show error, or just ignore (might not be a valid use-case)
});
